const MenuItemName = ({ className, style, displayCode, name }) => {
    return (
        <span className={className} style={style}>
            {displayCode ? `${displayCode}. ` : ''}
            {name}
        </span>
    );
};

export default MenuItemName;
